import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const EmailVerifyCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  const token = searchParams.get('token');
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

  // Utility function to get browser data for Meta CAPI
  const getBrowserData = () => {
    // Get Facebook Pixel Browser ID (fbp) from cookie
    const getFbp = () => {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === '_fbp') {
          return decodeURIComponent(value);
        }
      }
      return null;
    };

    // Get Facebook Click ID (fbc) from URL or cookie
    const getFbc = () => {
      // First try URL parameter
      const urlParams = new URLSearchParams(window.location.search);
      const fbclid = urlParams.get('fbclid');
      if (fbclid) {
        return `fb.1.${Date.now()}.${fbclid}`;
      }
      
      // Then try cookie
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === '_fbc') {
          return decodeURIComponent(value);
        }
      }
      return null;
    };

    return {
      user_agent: navigator.userAgent,
      fbp: getFbp(),
      fbc: getFbc(),
      source_url: window.location.href
    };
  };

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link.');
        return;
      }
      try {
        // Collect browser data for Meta CAPI
        const browserData = getBrowserData();
        
        const resp = await axios.post(`${API_BASE_URL}/api/auth/verify-email`, { 
          token,
          browser_data: browserData
        });
        if (resp.data?.requires_approval) {
          setStatus('success');
          setMessage('Email verified! Account pending admin approval.');
          setTimeout(() => navigate('/login', { state: { verificationMessage: 'Your email is verified and pending approval.' } }), 1500);
        } else {
          setStatus('success');
          setMessage('Email verified successfully! You can now login.');
          setTimeout(() => navigate('/login', { state: { verificationMessage: 'Email verified! Please sign in.', fromRegistration: false } }), 2000);
        }
      } catch (e) {
        setStatus('error');
        setMessage(e.response?.data?.detail || 'Verification failed. Please request a new link.');
        setTimeout(() => navigate('/verification-pending'), 2500);
      }
    };
    verify();
  }, [token, API_BASE_URL, navigate]);

  return (
    <div className="auth-container">
      <div className="auth-card text-center">
        {status === 'loading' && <p>Verifying your email...</p>}
        {status === 'success' && <p style={{ color: '#16a34a' }}>{message}</p>}
        {status === 'error' && <p style={{ color: 'var(--color-danger-hover)' }}>{message}</p>}
      </div>
    </div>
  );
};

export default EmailVerifyCallback;